import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { Company, FeatureFlagKey } from 'src/DTO/Company.type';
import { useGetCompanies } from 'src/api/hooks/useCompany';
import { useStoreActions } from 'src/stores';
import { useTranslation } from 'react-i18next';
import { PopUpEnum } from 'src/stores/NotificationStore';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { headers } from './companylist.headers';
import { SwipableCompanyDetails } from './SwipableCompanyDetail';
import { useGetFeatureFlags } from 'src/api/hooks/useFeatureFlag';

export const CompanyList: React.FC = () => {
  const { t } = useTranslation();
  const [companies, setCompanies] = useState<Company[] | undefined>(undefined);
  const setPopUpData = useStoreActions(action => action.popUp.setPopUp);

  const [selectedCompany, setSelectedCompany] = useState<Company | undefined>(undefined);
  const [availableFeatureFlags, setAvailableFeatureFlags] = useState<FeatureFlagKey[]>([]);

  const [getCompanies] = useGetCompanies({
    onComplete: res => {
      if (!res) return;
      setCompanies(res);
    },
    onError: () => {
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.error,
        message: t('alerts.managerProfileListScreen.error'),
      });
    },
  });

  const [getFeatureFlags] = useGetFeatureFlags({
    onComplete: res => {
      if (!res) return;
      setAvailableFeatureFlags(res);
    },
    onError: () => {
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.error,
        message: t('alerts.getFeatureFlags.error'),
      });
    },
  });

  useEffect(() => {
    getCompanies();
    getFeatureFlags();
  }, []);

  return (
    <Grid style={{ height: '100%' }}>
      <DataGrid
        autoHeight
        components={{ Toolbar: GridToolbar }}
        componentsProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
        autoPageSize
        rows={companies || []}
        columns={headers(t, availableFeatureFlags)}
        loading={!companies}
        onCellClick={params => {
          if (params.field === 'featureFlags') return;
          setSelectedCompany(params.row);
        }}
        disableSelectionOnClick
        pageSize={100}
        rowsPerPageOptions={[5, 20]}
      />
      <SwipableCompanyDetails
        data={selectedCompany}
        onClose={() => setSelectedCompany(undefined)}
      />
    </Grid>
  );
};
